import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="bg-light py-3">
      <div className="container d-flex justify-content-between align-items-center">
        {/* App Name (Left) */}
        <h1 className="mb-0">School of Service</h1>

        {/* Search Bar (Center) */}
        <div className="w-50">
          <input 
            type="text" 
            className="form-control" 
            placeholder="Search..." 
          />
        </div>

        {/* Buttons (Right) */}
        <div>
          <Link to="/login">
            <button className="btn btn-primary me-2">Login</button>
          </Link>
          <Link to="/register">
            <button className="btn btn-secondary">Register</button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
